/* Grihvas photo zoom: hover lens on desktop + full-screen "glow" viewer (swipe, tap/double-tap to zoom, drag to pan) */
(function () {
  var fine = window.matchMedia && matchMedia('(hover:hover) and (pointer:fine)').matches;
  var ICON_ZOOM = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M11 8v6M8 11h6M20 20l-4-4"/></svg>';
  function big(src) { return src ? src.replace(/([?&])width=[0-9]+/, '$1width=2000') : src; }

  function slides(g) {
    var imgs = Array.prototype.slice.call(g.querySelectorAll('[data-gv-media]'));
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-gv-thumb]')).filter(function (t) { return !t.hidden; });
    if (!thumbs.length) return imgs;
    return thumbs.map(function (t) { return imgs.filter(function (i) { return i.dataset.gvMedia === t.dataset.gvThumb; })[0]; }).filter(Boolean);
  }

  function openViewer(g, fromEl) {
    var list = slides(g);
    if (!list.length) return;
    var active = g.querySelector('[data-gv-media].is-active');
    var start = Math.max(0, list.indexOf(active));
    var r = (fromEl || g).getBoundingClientRect();
    var ov = document.createElement('div');
    ov.className = 'gv-viewer';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-label', 'Product photos');
    ov.style.setProperty('--ox', Math.round(r.left + r.width / 2) + 'px');
    ov.style.setProperty('--oy', Math.round(r.top + r.height / 2) + 'px');
    var html = '<div class="gv-viewer__top"><span class="gv-viewer__count" aria-live="polite"></span><button type="button" class="gv-viewer__close" aria-label="Close">&times;</button></div><div class="gv-viewer__track">';
    list.forEach(function (im) { html += '<div class="gv-viewer__slide"><img src="' + big(im.currentSrc || im.src) + '" alt="' + (im.alt || '').replace(/"/g, '&quot;') + '" draggable="false"></div>'; });
    html += '</div><div class="gv-viewer__strip">';
    list.forEach(function (im, i) { html += '<button type="button" class="gv-viewer__dot" aria-label="Photo ' + (i + 1) + '"><img src="' + (im.currentSrc || im.src) + '" alt=""></button>'; });
    html += '</div><p class="gv-viewer__tip">' + (fine ? 'Click a photo to zoom · move to explore' : 'Double-tap to zoom · drag to explore') + '</p>';
    ov.innerHTML = html;
    document.body.appendChild(ov);
    document.documentElement.classList.add('gv-noscroll');

    var track = ov.querySelector('.gv-viewer__track');
    var dots = Array.prototype.slice.call(ov.querySelectorAll('.gv-viewer__dot'));
    var count = ov.querySelector('.gv-viewer__count');
    var cur = start;
    function mark(i) {
      cur = i;
      count.textContent = (i + 1) + ' / ' + list.length;
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      if (dots[i]) dots[i].scrollIntoView({ block: 'nearest', inline: 'center' });
    }
    function go(i, smooth) { track.scrollTo({ left: i * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' }); mark(i); }
    requestAnimationFrame(function () { go(start, false); ov.classList.add('is-open'); });
    track.addEventListener('scroll', function () { var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); if (i !== cur) { unzoomAll(); mark(i); } }, { passive: true });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { unzoomAll(); go(i, true); }); });

    /* zoom inside a slide */
    function unzoomAll() { ov.querySelectorAll('.gv-viewer__slide.is-zoomed').forEach(function (s) { s.classList.remove('is-zoomed'); }); track.classList.remove('is-locked'); }
    function setOrigin(slide, x, y) {
      var b = slide.getBoundingClientRect();
      var px = Math.min(100, Math.max(0, (x - b.left) / b.width * 100));
      var py = Math.min(100, Math.max(0, (y - b.top) / b.height * 100));
      slide.querySelector('img').style.transformOrigin = px + '% ' + py + '%';
    }
    function toggle(slide, x, y) {
      var on = !slide.classList.contains('is-zoomed');
      unzoomAll();
      if (on) { setOrigin(slide, x, y); slide.classList.add('is-zoomed'); track.classList.add('is-locked'); }
    }
    var lastTap = 0;
    ov.querySelectorAll('.gv-viewer__slide').forEach(function (s) {
      var down = null;
      s.addEventListener('pointerdown', function (e) { down = { x: e.clientX, y: e.clientY }; });
      s.addEventListener('pointerup', function (e) {
        if (e.target.tagName !== 'IMG') return;
        if (down && (Math.abs(e.clientX - down.x) > 10 || Math.abs(e.clientY - down.y) > 10)) { lastTap = 0; return; }
        if (e.pointerType === 'mouse') { toggle(s, e.clientX, e.clientY); return; }
        var now = Date.now();
        if (now - lastTap < 320) { toggle(s, e.clientX, e.clientY); lastTap = 0; } else { lastTap = now; }
      });
      s.addEventListener('pointermove', function (e) { if (s.classList.contains('is-zoomed')) setOrigin(s, e.clientX, e.clientY); });
    });

    function close() {
      ov.classList.remove('is-open');
      ov.classList.add('is-closing');
      document.documentElement.classList.remove('gv-noscroll');
      document.removeEventListener('keydown', onKey);
      var target = list[cur];
      if (target && typeof g.show === 'function') g.show(target.dataset.gvMedia);
      setTimeout(function () { ov.remove(); }, 320);
      if (fromEl && fromEl.focus) fromEl.focus();
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight' && cur < list.length - 1) { unzoomAll(); go(cur + 1, true); }
      if (e.key === 'ArrowLeft' && cur > 0) { unzoomAll(); go(cur - 1, true); }
    }
    document.addEventListener('keydown', onKey);
    ov.querySelector('.gv-viewer__close').addEventListener('click', close);
    ov.querySelector('.gv-viewer__close').focus();
  }

  function init() {
    var g = document.querySelector('gv-gallery');
    if (!g) return;
    var main = g.querySelector('.gv-gallery__main');
    if (!main || main.dataset.gvZoom || !main.querySelector('[data-gv-media]')) return;
    main.dataset.gvZoom = '1';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gv-zoom-btn';
    btn.setAttribute('aria-label', 'View photos full screen');
    btn.innerHTML = ICON_ZOOM;
    main.appendChild(btn);
    var hint = document.createElement('span');
    hint.className = 'gv-zoom-hint';
    hint.textContent = fine ? 'Hover to zoom' : 'Tap to view';
    main.appendChild(hint);
    setTimeout(function () { hint.classList.add('is-gone'); }, 3200);

    if (fine) {
      main.addEventListener('mousemove', function (e) {
        var im = main.querySelector('img.is-active');
        if (!im) return;
        var b = main.getBoundingClientRect();
        im.style.transformOrigin = ((e.clientX - b.left) / b.width * 100) + '% ' + ((e.clientY - b.top) / b.height * 100) + '%';
        main.classList.add('is-lens');
      });
      main.addEventListener('mouseleave', function () { main.classList.remove('is-lens'); });
    }
    main.addEventListener('click', function () { openViewer(g, btn); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();